import { createFileRoute, redirect } from '@tanstack/react-router'
import { useSelectedTenantStore } from '@/stores/useSelectedTenantStore'

// Redirector: /documents/trash -> /org/$orgId/documents/trash
export const Route = createFileRoute(
  '/_authenticated/_dashboard/documents/trash/',
)({
  component: () => null,
  beforeLoad: async () => {
    const store = useSelectedTenantStore.getState()
    if (store.selectedTenantId) {
      throw redirect({
        to: '/org/$orgId/documents/trash',
        params: { orgId: store.selectedTenantId },
        search: (prev) => prev,
      })
    }
    throw redirect({ to: '/select-tenant' })
  },
})
